export const cookiesPolicyData = {
  CookiesPolicy: {
    Heading: "ESquadifi Cookies Policy",
    SubHeading: "Effective Date: September 14, 2024",
    Steps: [
      {
        title: "1. Introduction",
        content: [
          `This Cookies Policy explains how Squadifi LTD ("Squadifi", "we", "our", or "us") uses cookies and similar tracking technologies on our platform. By using our platform, you agree to the use of cookies as outlined in this policy. This policy is intended to be read in conjunction with our Privacy Policy.`,
        ],
      },
      {
        title: "2. What are Cookies?",
        content: [
          "Cookies are small text files stored on your device (computer, mobile, tablet) when you visit websites. They help us recognise your device and improve the user experience by remembering your preferences, enabling certain functionalities, and providing insight into how the platform is used.",
        ],
      },
      {
        title: "3. Types of Cookies We Use",
        content: [
          "We use various types of cookies on our platform, each serving a different purpose:",
        ],
        subSteps: [
          {
            subTitle: "A. Essential Cookies",
            subContent: [
              "These cookies are necessary for the operation of the platform. They enable basic functionalities such as page navigation, secure login, and access to protected areas. Without these cookies, the platform may not function properly.",
            ],
          },
          {
            subTitle: "B. Performance and Analytics Cookies",
            subContent: [
              "These cookies allow us to measure and improve the performance of our platform by collecting information on how users interact with the platform. We use this data to optimise user experience, identify popular features, and detect issues.",
            ],
          },
          {
            subTitle: "C. Functionality Cookies",
            subContent: [
              "Functionality cookies enable the platform to remember your choices and preferences (such as language, region, or username) to provide a more personalised experience. These cookies may also be used to provide specific services, such as remembering if you have already completed certain tasks.",
            ],
          },
          {
            subTitle: "D. Advertising and Targeting Cookies",
            subContent: [
              "Advertising cookies are used to track your browsing activity on our platform and other sites to show you relevant ads based on your interests. We also use these cookies to limit the number of times you see a particular ad and measure the effectiveness of our marketing campaigns.",
            ],
          },
          {
            subTitle: "E. Third-Party Cookies",
            subContent: [
              "We may allow third-party service providers to place cookies on your device through our platform to provide us with insights about the performance of our platform, for advertising purposes, or for social media sharing features. These third parties may collect information about your online activities across different websites and services.",
            ],
          },
        ],
      },
      {
        title: "4. How We Use Cookies",
        content: ["We use cookies for the following purposes:"],
        subContent: [
          "To enable you to log in and use our platform securely.",
          "To recognise your preferences and settings when you return to the platform.",
          "To collect analytics and usage data to improve the functionality and performance of our services.",
          "To deliver targeted advertising and measure the effectiveness of ad campaigns.",
        ],
      },
      {
        title: "5. Your Cookie Preferences",
        subSteps: [
          {
            subTitle: "A. Managing Cookies",
            subContent: [
              "Most browsers allow you to manage cookies through their settings. You can choose to block, delete, or limit cookies, but doing so may affect the functionality of our platform. To manage your cookie preferences, consult your browser’s help section or settings.",
            ],
          },
          {
            subTitle: "B. Opting Out of Targeted Advertising",
            subContent: [
              "If you do not wish to receive targeted advertising, you can opt out of interest-based ads by adjusting your browser settings or by using third-party tools, such as those provided by the Network Advertising Initiative or Digital Advertising Alliance.",
            ],
          },
        ],
      },
      {
        title: "6. Changes to This Cookies Policy",
        content: [
          "We may update this Cookies Policy from time to time to reflect changes in technology, legal requirements, or our platform’s functionality. Any updates will be posted on this page, and your continued use of the platform after such updates signifies your acceptance of the revised policy.",
        ],
      },
      {
        title: "7. Contact Us",
        content: [
          "For more information about our use of cookies or if you have any questions about this Cookies Policy, please contact us at:\nSquadifi LTD\n1st Floor, 85 Mercian Way, Edgeley, Stockport, SK3 9DF, England\nEmail: support@esquadifi.io",
        ],
      },
    ],
  },
};
